import { Input, InputProps } from '@chakra-ui/react';
import { ForwardedRef, forwardRef } from 'react';

export interface ZipCodeInputProps extends Omit<InputProps, 'placeholder' | 'type' | 'maxLength'> {}

const formatZipCode = (value: string) => {
    const digits = value.replace(/\D/g, '');
    const length = digits.length;

    if (length <= 5) {
        return digits;
    }

    return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
};

const zipCodeInput = ({ value, onChange, ...inputProps }: ZipCodeInputProps, ref: ForwardedRef<HTMLInputElement | null>) => {
    const formattedValue = formatZipCode(value ? String(value) : '');

    return (
        <Input
            {...inputProps}
            ref={ref}
            type="text"
            placeholder="12345-6789"
            value={formattedValue}
            onChange={(e) => {
                const unformattedValue = e.target.value.replace(/\D/g, '');
                if (unformattedValue.length > 9) {
                    return;
                }
                e.target.value = unformattedValue.slice(0, 9);
                onChange?.(e);
            }}
        />
    );
};

zipCodeInput.displayName = 'ZipCodeInput';

export const ZipCodeInput = forwardRef(zipCodeInput);
